export const ActionTypes = {
	COUNTERS_GET: 'COUNTERS_GET',
	FEATURES_GET: 'FEATURES_GET',
	TRACKING_VERIFY: 'TRACKING_VERIFY'
};
